var modules_af19274f = {"bubble":"_rntj5w","arrow":"_1o0m6qt","content":"_1gojv6t","iconWrapper":"_lq4l1d","badge":"_1txaf0b","badgeWrapper":"_g6ra0"};
import "../../../assets/H2dDI4Lm.css";

export { modules_af19274f as default };
//# sourceMappingURL=partner-badge.module.scss.js.map
